import { createSvgIcon } from "@mui/material";

export const Icon = createSvgIcon(
  <>
    <g>
      <path d="M6.3,4.32h-3.82c-.51,0-.96-.45-.96-.96s.45-.96.96-.96h3.82c.51,0,.96.45.96.96s-.45.96-.96.96Z" />
      <path d="M6.3,11.97h-3.82c-.51,0-.96-.45-.96-.96s.45-.96.96-.96h3.82c.51,0,.96.45.96.96s-.45.96-.96.96Z" />
      <path d="M6.3,15.8h-3.82c-.51,0-.96-.45-.96-.96s.45-.96.96-.96h3.82c.51,0,.96.45.96.96s-.45.96-.96.96Z" />
      <path d="M13.94,8.14h-3.82c-.51,0-.96-.45-.96-.96s.45-.96.96-.96h3.82c.51,0,.96.45.96.96s-.45.96-.96.96Z" />
      <path d="M13.94,11.97h-3.82c-.51,0-.96-.45-.96-.96s.45-.96.96-.96h3.82c.51,0,.96.45.96.96s-.45.96-.96.96Z" />
      <path d="M21.59,4.32h-3.82c-.51,0-.96-.45-.96-.96s.45-.96.96-.96h3.82c.51,0,.95.45.95.96s-.45.96-.95.96Z" />
      <path d="M21.59,8.14h-3.82c-.51,0-.96-.45-.96-.96s.45-.96.96-.96h3.82c.51,0,.95.45.95.96s-.45.96-.95.96Z" />
      <path d="M21.59,15.8h-3.82c-.51,0-.96-.45-.96-.96s.45-.96.96-.96h3.82c.51,0,.95.45.95.96s-.45.96-.95.96Z" />
    </g>
    <g>
      <path d="M2.35,20.12c0,.69.39,1.06.84,1.06.41,0,.86-.35.86-1.06s-.43-1.04-.84-1.04c-.45,0-.86.32-.86,1.04ZM2.35,17.3v1.68c.19-.3.54-.6,1.12-.6.65,0,1.42.54,1.42,1.73s-.73,1.83-1.49,1.83c-.43,0-.8-.19-1.03-.58v.47h-.84v-4.53h.82Z" />
      <path d="M6.11,20.14c0,.71.43,1.04.84,1.04.45,0,.84-.3.84-1.04s-.39-1.06-.84-1.06c-.39,0-.84.32-.84,1.06ZM5.3,20.1c0-1.16.75-1.75,1.51-1.75.41,0,.75.15,1.01.52v-.43h.82v3.39h-.82v-.47c-.24.32-.58.56-1.12.56-.65,0-1.4-.56-1.4-1.81Z" />
      <path d="M10.25,19.91v1.92h-.82v-3.36h.82v.5c.24-.43.67-.58,1.03-.58.58,0,1.14.3,1.14,1.21v2.24h-.82v-1.94c0-.56-.28-.78-.65-.78-.41.02-.71.26-.71.8Z" />
      <path d="M13.2,17.3v4.53h.82v-.82l.45-.56.93,1.38h.9l-1.33-1.96,1.16-1.4h-.93l-1.18,1.55v-2.72h-.82Z" />
      <path d="M17.93,17.45h-.84v4.38h.84v-4.38Z" />
      <path d="M20.37,17.45h-1.59v4.38h1.59c1.18,0,2.17-.71,2.17-2.2s-.99-2.18-2.17-2.18ZM20.37,21.05h-.75v-2.83h.75c.69,0,1.27.45,1.27,1.42s-.58,1.4-1.27,1.4Z" />
    </g>
  </>,
  "BankID NO",
);

export default Icon;
